// import Lottie from 'lottie-react';

import LogoImg from 'assets/img/logo.png';

// const santa = require('../../assets/lottie/santa.json');
// const gorro = require('../../assets/lottie/gorro_natal.json');

type LogoProps = {
  mobile?: boolean;
};

const Logo = ({ mobile }: LogoProps) => {
  let cssSanta = '-right-[90px] w-[180px] top-[2px]';
  let cssGorro = '-left-[25px] -top-1 w-[150px]';

  if (mobile) {
    cssSanta = '-right-10 w-[80px] -top-[2px]';
    cssGorro = '-left-2 -top-1 w-[60px]';
  }

  return (
    <>
      <img src={LogoImg} alt="Reconheça BRB" className="relative rounded" />
      {/* <Lottie className={`absolute ${cssSanta} lg:-right-[140px] lg:top-0 lg:w-[280px]`} animationData={santa} loop={true} />
      <Lottie
        className={`${cssGorro} absolute lg:-left-7 lg:-top-4 lg:w-[230px] transform scale-x-[-1] -rotate-12`}
        animationData={gorro}
        loop={true}
      /> */}
    </>
  );
};

export default Logo;
